import { Component, input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'vx-stats-card',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <article class="stat">
      <div class="stat-top">
        <span>{{ label() }}</span>
        <lucide-icon name="activity" [size]="18" />
      </div>
      <strong>{{ value() }}</strong>
      <small>{{ trend() }}</small>
    </article>
  `,
  styles: [`
    .stat {
      padding: 18px;
      border-radius: 16px;
      color: white;
      background: linear-gradient(145deg, rgba(255,255,255,.13), rgba(255,255,255,.05));
      border: 1px solid rgba(255,255,255,.12);
      animation: reveal 650ms ease both;
    }
    .stat-top {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      align-items: center;
    }
    span, small { color: rgba(255,255,255,.68); font-weight: 800; }
    lucide-icon { color: rgba(255,255,255,.8); }
    strong {
      display: block;
      font-family: "Space Grotesk";
      font-size: 2rem;
      margin: 10px 0 4px;
    }
  `]
})
export class StatsCardComponent {
  label = input.required<string>();
  value = input.required<number | string>();
  trend = input.required<string>();
}
